import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
  Alert,
  PanResponder,
} from "react-native";
import FilterBar from "app/components/FilterBar";
import Text from "app/components/Text";
import Value from "app/components/Value";
import Pannable from "app/components/Pannable";
import Draggable from "app/components/Draggable";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  phi,
  inversePhi,
} from "app/utils/styleSheet";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import store from "app/redux/store";

export default class Fractal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: [],
      loading: true,
      fetching: true,
      query: "",
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
      quickActionsId: null,
      redrawKey: 0,
    };
  }

  async componentDidMount() {
    await this.fetch();
    store.subscribe(() => {
      let { app, values } = store.getState();
      this.setState({
        values,
        loading: app.loading,
      });
    });
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
  }

  fetch = async () => {
    let { values, lastPressedId } = this.state;
    let prevValues = values;
    await this.setState({ fetching: true });
    let pref = await prefActions.get();
    await this.setState({
      hiddenIds: pref.hidden_ids,
      todoIds: pref.todo_ids,
      focusIds: pref.focus_ids,
      filters: pref.filters,
      prefsLoaded: true,
    });
    let newValues = await valueActions.index();
    if (!!newValues) {
      this.updateValuesToRender(newValues);
      this.setState({ values: newValues, fetching: false, loading: false });
    }
  };

  render() {
    let {
      values,
      fetching,
      query,
      selectedValue,
      quickActionsId,
      redrawKey,
      loading,
      showFocus,
    } = this.state;

    return (
      <View style={styles.container} key={redrawKey}>
        <StatusBar style="auto" />
        {ENV.WEB && !!showFocus && (
          <Canvas lines={lines} scrollHeight={scrollHeight} />
        )}

        <FilterBar />

        <Pannable style={styles.container}>
          <View style={styles.content}>
            <TouchableWithoutFeedback
              onPress={() => this.setState({ selectedValue: null })}
            >
              <View style={[styles.content]}>
                <View style={{ position: "absolute", borderWidth: 0 }}>
                  {!loading && this.renderBud(selectedValue, undefined, true)}
                </View>
              </View>
            </TouchableWithoutFeedback>
          </View>
        </Pannable>

        <View />
      </View>
    );
  }

  renderBud = (value = null, size = 200, crux = false) => {
    let { values, familyIds, selectedValue, quickActionsId } = this.state;
    // values = values
    let valueToRender;
    let valuesToRender = values;

    let sizeRatio = size * screenRatio;

    if (!value) {
      let levelIds = valueHelpers.getLevelIds(values);
      let topLevel = valueHelpers.getTopLevel(levelIds);
      values = values.filter((v) => {
        let level = valueHelpers.getLevel(v);
        return level >= topLevel - 1;
      });
      // values = values.filter(v => !v.parent_ids.length)
      // values = [values[0]]
      valueToRender = (
        <View
          style={[
            styles.crux,
            {
              width: sizeRatio,
              height: sizeRatio,
              borderRadius: sizeRatio / 2,
              // margin: size/9,
            },
          ]}
          pointerEvents={"none"}
        />
      );
    } else {
      values = valueHelpers.getChildren({ value });
      valueToRender = (
        <Value
          // childrenRing
          size={size}
          value={value}
          ref={(ref) => {
            this[`val_${value.id}`] = ref;
          }}
          selected={selectedValue?.id == value.id}
          onDeselect={() => this.hoverOut(value)}
          // onLongPress={undefined}
          onPress={() => {
            console.log(value);
            this.setState({ selectedValue: value });
            return;
            this.setState({ lastPressedId: value.id });
            if (!!quickActionsId) {
              this.setState({ quickActionsId: null });
            }
            // else if(true) {
            else if (false) {
              RootNavigation.navigate("Value", { value, id: value.id });
            } else if (!!selectedValue && selectedValue.id == value.id) {
              RootNavigation.navigate("Value", { value, id: value.id });
            } else if (selected) {
              this.hoverIn(value);
            } else if (!!selectedValue) {
              this.hoverOut();
            } else {
              this.hoverIn(value);
            }
          }}
          style={
            [
              // crux ? { borderWidth: 3} : null,
            ]
          }
          maxWidth={250}
          // onUpdate={val => this.handleUpdate(val)}
          showQuickActions={quickActionsId == value.id}
          onShowQuickActions={() => this.setState({ quickActionsId: value.id })}
          onHideQuickActions={() => this.setState({ quickActionsId: null })}
          onSelect={ENV.WEB ? () => this.hoverIn(value) : undefined}
          hiddenIds={this.state.hiddenIds}
          todoIds={this.state.todoIds}
          focusIds={this.state.focusIds}
          showFocusRing={!!this.state.showFocus}
        />
      );
    }

    let leafSize = size * inversePhi;
    let leafSizeRatio = leafSize * screenRatio;
    let wedge = 180 / values.length;
    if (crux) wedge = 360 / values.length;
    return (
      <View
        style={[
          !crux
            ? {
                position: "absolute",
                left: -leafSizeRatio,
                // borderWidth: 1, borderColor: 'red',
              }
            : {
                position: "absolute",
                // top: -leafSizeRatio,
                // left: -leafSizeRatio,
                top: -sizeRatio / 2,
                left: -sizeRatio / 2,
                width: sizeRatio,
                height: sizeRatio,
                // borderWidth: 2, borderColor: 'blue',
                justifyContent: "center",
                alignItems: "center",
              },
        ]}
      >
        {valueToRender}

        {values.map((v, i) => {
          let rot = wedge * (i + 1);
          // rot = wedge * i
          rot -= 90;
          rot -= wedge / 2;
          if (!value?.id) {
            rot = wedge * i;
          }
          return (
            <View
              key={i}
              style={{
                width: 0,
                // alignItems: 'center',
                position: "absolute",
                left: crux ? sizeRatio / 2 : leafSizeRatio,
                top: -leafSizeRatio,
                bottom: -leafSizeRatio,
                // borderWidth: 1, borderColor: 'red',
                transform: [
                  // {translateY: spacingSize},
                  { rotateZ: `${rot}deg` },
                ],
              }}
            >
              <View
                style={{
                  transform: [
                    // {rotateZ: `-${rot}deg`},
                  ],
                  // borderWidth: 1, borderColor: 'yellow',
                }}
              >
                {this.renderBud(v, leafSize)}
              </View>
            </View>
          );
        })}
      </View>
    );
  };

  updateValuesToRender = (values = null) => {
    if (values == null) values = this.state.values;
    let valuesToRender = valueHelpers.onlyRecentRevisions(values);
    if (this.filterBar)
      valuesToRender = this.filterBar.applyFilters(valuesToRender);
    valuesToRender = valueHelpers.sortByTimeline(valuesToRender);
    this.setState({ valuesToRender });
  };

  handleUpdate = async (val, newPrefs = null) => {
    let values = this.state.values.map((v) =>
      v.id == val.id ? { ...v, ...val } : v
    );

    values = valueHelpers.sortByTimeline(values);
    storageActions.saveItem("values", values);
    // values = valueHelpers.onlyRecentRevisions(values)
    // if(this.filterBar) values = this.filterBar.applyFilters(values)
    // values = valueHelpers.sortByTimeline(values)
    this.updateValuesToRender(values);
    // values = valueHelpers.applyLevels(values)

    console.log("handleupdate:", val, newPrefs);
    // if(!!newPrefs){
    //   this.setState({...newPrefs})
    // }
    let pref = await prefActions.get(true);
    await this.setState({
      // values,
      query: "",
      hiddenIds: pref.hidden_ids,
      todoIds: pref.todo_ids,
      focusIds: pref.focus_ids,
      // filters: pref.filters,
      query: "",
    });
    await this.setState({ values });
  };

  hoverIn = async (value) => {
    // this.setState({pendingSelectedValue: value})
    // await new Promise(resolve => setTimeout(resolve, 2000));
    // if(this.state.pendingSelectedValue?.id != value.id) return
    console.log(value);
    let { values } = this.state;
    let familyIds = [value.id];
    let lines = [];

    if (CONSTELATE) lines = [...lines, ...this.constelate(value, true)];

    // let familyIds = textHelpers.getFamilyIds(value)

    let parentIds = value.parent_ids;
    while (parentIds.length) {
      familyIds = [...familyIds, ...parentIds];
      let parents = values.filter((v) => parentIds.includes(v.id));
      parentIds = parents.map((v) => v.parent_ids).flat();
      if (CONSTELATE)
        parents.forEach(
          (val) => (lines = [...lines, ...this.constelate(val, true)])
        );
    }

    if (CONSTELATE) lines = [...lines, ...this.constelate(value, false)];

    let childIds = value.child_ids;
    while (childIds.length) {
      familyIds = [...familyIds, ...childIds];
      let children = values.filter((v) => childIds.includes(v.id));
      childIds = children.map((v) => v.child_ids).flat();
      if (CONSTELATE)
        children.forEach(
          (val) => (lines = [...lines, ...this.constelate(val, false)])
        );
    }

    familyIds = [...new Set(familyIds)];
    this.setState({
      familyIds,
      lines,
      selectedValue: value,
      quickActionsId: null,
    });
  };

  hoverOut = (value = null) => {
    this.setState({
      familyIds: [],
      selectedValue: null,
      pendingSelectedValue: null,
      lines: [],
    });
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
    alignItems: "stretch",
    // borderWidth: 2, borderColor:'white'
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
  },
  row: {
    flexGrow: 1,
    borderColor: colors.trim,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-around",
  },
  valueWrapper: {
    flex: 1,
    alignSelf: "stretch",
    justifyContent: "center",
    alignItems: "center",
  },
  crux: {
    // backgroundColor: colors.empty,
    backgroundColor: "rgba(0,0,0,0.8)",
    borderWidth: 4,
    borderColor: colors.foreground,
  },
});
